const mergeContinuousLevels = (levels) => {
  const mergedLevels = [];
  let currentLevel = levels[0];

  for (let i = 1; i < levels.length; i++) {
    const [start1, end1] = currentLevel.split('-');
    const [start2, end2] = levels[i].split('-');

    if (parseInt(end1) + 1 === parseInt(start2)) {
      currentLevel = `${start1}-${end2}`;
    } else {
      mergedLevels.push(currentLevel);
      currentLevel = levels[i];
    }
  }

  mergedLevels.push(currentLevel);
  return mergedLevels;
}

const convertToEmbedUrl = (url) => {
  try {
      // Check if the URL contains "/e/" and "/pub"
      var match = url.match(/\/e\/([^/]+)\/pub/);
      if (match) {
          // If "/e/" is found, append "?embedded=true" to the URL
          var modifiedUrl = url.replace(match[0], match[0] + "?embedded=true");
          return modifiedUrl;
      }

      // If "/e/" is not found, proceed with the regular conversion
      match = url.match(/\/(document|presentation|spreadsheets|forms|drawings)\/d\/([^/]+)/);
      if (!match) {
          return url;
          // throw new Error("Invalid Google Docs URL");
      }

      var docType = match[1];
      var docId = match[2];
      var embedUrl = null;

      switch (docType) {
          case 'document':
              embedUrl = `https://docs.google.com/${docType}/d/${docId}/preview`;
              break;
          case 'presentation':
              embedUrl = `https://docs.google.com/${docType}/d/${docId}/embed`;
              break;
          default:
              embedUrl = `https://docs.google.com/${docType}/d/${docId}`;
              break;
      }

      // Return the embed URL
      return embedUrl;
  } catch (error) {
      return url;
      // console.error("Invalid URL:", error);
      // return null;
  }
}

const extractSrcUrlFromIframeString = (iframeString) => {
  if(!iframeString)
      return null;
  let srcRegex = /src="([^"]+)"/;
  var match = iframeString.match(srcRegex);
  if (match && match.length > 1) {
      return match[1];
  }
  return null;
}

// Note: Meilisearch does not have built-in analytics like Algolia Insights
// If you need analytics, you'll need to implement custom event tracking
// or use a third-party analytics solution

import { usePage } from '@inertiajs/vue3'

const initAndGetAlgoliaEventDispatcher = () => {
  // Algolia-specific analytics have been removed
  // Meilisearch analytics are now handled by MeilisearchAnalytics.js
  // This function is kept for backward compatibility but does nothing
  return () => {};
}

const sortGradeBands = (a, b) =>{
  // Handle null cases
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const parseValue = (val) => {
      // If "PK", return -1 to represent Pre-Kindergarten
      if (val === "PK" || val === 'pk') return -1;
      // If "K", return 0 to represent Kindergarten
      if (val === "K" || val === 'k') return 0;
      // If "AP", return Infinity to ensure it's always last
      if (val === "AP" || val === 'ap') return Infinity;
      return parseInt(val); // Convert numeric part to an integer
  };

  let startA = a.split('-')[0]; // Get the starting value of range a
  let startB = b.split('-')[0]; // Get the starting value of range b

  return parseValue(startA) - parseValue(startB); // Sort based on the starting value
}





/**
 * Detects if a search query starts with a standard code (e.g. MS-LS1-1, CCSS.ELA-LITERACY.W.6.7, 3-LS3-1)
 * and wraps the code portion in quotes for exact matching in Meilisearch.
 *
 * Standard codes are identified by: alphanumeric segments joined by dots or hyphens,
 * containing at least one digit and one uppercase letter.
 */
const formatSearchQuery = (query) => {
    if (!query) return query;
    const trimmed = query.trim();
    // Match a code-like prefix: alphanumeric segments joined by dots or hyphens (at least 2 segments)
    const codePattern = /^[A-Za-z0-9]+([.\-][A-Za-z0-9]+){1,}/;
    const match = trimmed.match(codePattern);
    if (!match) return trimmed;
    const code = match[0];
    // Must contain at least one digit and one uppercase letter to be a standard code
    if (!/[0-9]/.test(code) || !/[A-Z]/.test(code)) return trimmed;
    // Wrap the code in quotes for exact phrase matching, keep the rest as-is
    const rest = trimmed.slice(code.length).trim();
    return rest ? `"${code}" ${rest}` : `"${code}"`;
}

export { mergeContinuousLevels, convertToEmbedUrl , extractSrcUrlFromIframeString, initAndGetAlgoliaEventDispatcher, sortGradeBands, formatSearchQuery}
